var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 40,
    height: 6,
    fill: "#00A2E8",
    rx: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 30,
    height: 6,
    fill: "#00A2E8",
    rx: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 40,
    height: 6,
    fill: "#00A2E8",
    rx: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitle);
export default __webpack_public_path__ + "static/media/title.2ec71b3843e73de1aadb8ee17590d711.svg";
export { ForwardRef as ReactComponent };